$.extend($.validator.messages, {
	required: "Заполните поле",
	remote: "Введите правильное значение",
	email: "Введите корректную электронную почту",
	url: "Введите корректный URL",
	date: "Введите корректную дату",
	dateISO: "Введите корректную дату в формате ISO",
	number: "Введите число",
	digits: "Вводите только цифры",
	letters: "Вводите только буквы",
	creditcard: "Введите правильный номер кредитной карты",
	equalTo: "Пароли не совпадают",
	extension: "Выберите файл с правильным расширением",
	maxlength: $.validator.format("Максимальная длина описания - {0} символов"),
	minlength: $.validator.format("Введите не меньше {0} символов"),
	rangelength: $.validator.format(
		"Введите значение длиной от {0} до {1} символов"
	),
	range: $.validator.format("Введите число от {0} до {1}"),
	max: $.validator.format("Максимальная длина описания - {0} символов"),
	min: $.validator.format("Введите число, большее или равное {0}"),
});

function initValidate() {
	$(".js-validate").each((index, form) => {
		$(form)
			.find(
				'[type="submit"], [type="button"].but_green, [type="button"].but_round'
			)
			.prop("disabled", true);

		$(form).validate({
			ignore: [],
			errorElement: "span",
			errorClass: "label-error",
			rules: {
				password_confirm: {
					equalTo: ".js-password",
					minlength: 8,
				},
				"PasswordForm[newPasswordConfirm]": {
					equalTo: ".js-password",
					minlength: 8,
				},
			},
			highlight: function (element) {
				setTimeout(() => {
					if (!$(element).attr("disabled")) {
						$(element).parent().removeClass("is-success");
						$(element).parent().addClass("is-error");

						if ($(element).parent(".jq-checkbox")) {
							const checkboxParent = $(element).parents("label");
							checkboxParent.append(
								checkboxParent.find(".label-error")
							);
						}

						if (
							$(element).attr("type") == "checkbox" ||
							$(element).hasClass("select") ||
							$(element).attr("type") == "radio"
						) {
							const parent = $(element).parent();

							parent.append(parent.find(".label-error"));
						}
					}
				});
			},
			unhighlight: function (element) {
				setTimeout(() => {
					if (!$(element).attr("disabled")) {
						if ($(element).val() != "")
							$(element).parent().addClass("is-success");
						$(element).parent().removeClass("is-error");
					}
				});
			},
		});

		if ($(form).validate().checkForm()) {
			$(form)
				.find(
					'[type="submit"], [type="button"].but_green, [type="button"].but_round'
				)
				.prop("disabled", false);
		} else {
			$(form)
				.find(
					'[type="submit"], [type="button"].but_green, [type="button"].but_round'
				)
				.prop("disabled", true);
		}

		$("input:not(.js-uploadFileInput), textarea, select", $(form)).on(
			"focus change keyup",
			function () {
				const valid = $(form).validate().checkForm();
				const submit = $(form).find(
					'[type="submit"], [type="button"].but_green, [type="button"].but_round'
				);

				setTimeout(() => {
					if (
						!$(".js-uploadFileList")
							.find(".fieldset-file__active-load")
							.hasClass("file-error") &&
						valid
					) {
						submit.prop("disabled", false);
					} else {
						submit.prop("disabled", true);
					}
				}, 100);
			}
		);
	});
}

$(document).on("initValidateTrigger", () => {
	initValidate();
});

$(document).ready(() => {
	setTimeout(() => {
		$(document).trigger("initValidateTrigger");
	}, 500);
});

$(document).on("change input blur", ".application__input", (event) => {
	const _this = $(event.currentTarget);
	if (_this.val() == "") {
		_this.parent().removeClass("is-success");
	} else {
		_this.valid();
	}
});

$(document).on("change input blur", ".form-textarea textarea", (event) => {
	const _this = $(event.currentTarget);
	_this.valid();
});

let textarea = document.querySelector(".js-textareaAutoSize");

if ($(".js-textareaAutoSize").length > 0) {
	textarea.addEventListener("input", autosize);
}
if (document.querySelector(".js-textareaAutoSize")) {
	document.querySelectorAll(".js-textareaAutoSize").forEach((elem) => {
		elem.addEventListener("input", (event) => {
			const eventTar = event.target;
			eventTar.style.height = "5px";
			eventTar.style.height = `${eventTar.scrollHeight}px`;
		});
	});
}

function autosize() {
	var el = this;

	el.style.cssText = "padding:0";
	el.style.cssText = "height:" + el.scrollHeight + "px";
}

$(document).on("change", ".jq-checkbox input", (event) => {
	const _this = $(event.currentTarget);
	_this.valid();
});

$.validator.addMethod(
	"validpassword",
	function (value, element) {
		if (
			value.match(/[A-z]/) &&
			!value.match(/[А-я]/) &&
			value.match(/[A-Z]/)
		)
			return true;
	},
	"Пароль должен содержать от 8 символов, латинские символы, символы верхнего регистра"
);

$.validator.addClassRules("js-passwordValidate", {
	validpassword: true,
});

$(".js-passwordValidate").on("focus", function () {
	if ($(".js-passwordValidate").val() == "") {
		$(".js-passwordValidate").parent().addClass("is-error");
	}
});

$.validator.addMethod(
	"phonecustom",
	function (value, element) {
		if ($(element).hasClass("feedback-js-phone") && value === "") {
			return true;
		}
		if (value == "+7 (___) ___-__-__") return true;
		return value.match(/^\+7\s\([0-9]{3}\)\s[0-9]{3}\-[0-9]{2}\-[0-9]{2}$/);
	},
	"Пожалуйста, добавьте номер телефона, чтобы мы смогли с Вами связаться"
);

$(document).ready(function () {
	$(".js-phone").bind("input", function () {
		$.validator.addClassRules("js-phone", {
			phonecustom: true,
		});
	});
});

$.validator.addMethod(
	"emailcustom",
	function (value, element) {
		if ($(element).hasClass("feedback-js-email") && value === "") {
			return true;
		}

		return value.match(
			/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9A-Яа-я_\-\.])+\.([A-Za-zA-Яа-я_]{2,25})$/
		);
	},
	"Неправильный формат <br> электронной почты"
);

$.validator.addClassRules("js-email", {
	emailcustom: true,
});

$.validator.addMethod(
	"onlyletters",
	function (value, element) {
		return value.match(/^[a-zа-яA-ZА-ЯёЁ\s]+$/);
	},
	"Это поле может содержать только буквы"
);

$.validator.addClassRules("js-letters", {
	onlyletters: true,
});

$(document).ready(function () {
	$(".js-onlyText").bind("change keyup input click", function () {
		if (this.value.match(/[^а-яА-Яa-zA-Z\s]/g)) {
			this.value = this.value.replace(/[^а-яА-Яa-zA-Z\s]/g, "");
		}
	});
});

const emailField = $(".feedback-js-email");
const phoneField = $(".feedback-js-phone");

emailField.on("input", (event) => {
	const elem = $(event.currentTarget);

	if (elem.valid()) {
		phoneField.attr("required", false);
		phoneField.attr("placeholder", "+7 (___) ___-__-__");
		phoneField.valid();
	} else {
		phoneField.attr("placeholder", "+7 (___) ___-__-__*");
		phoneField.attr("required", true);
	}

	if (elem.val().length < 1 && phoneField.val().length < 1) {
		elem.attr("required", true);
		elem.attr("placeholder", "Введите e-mail*");
		phoneField.attr("required", true);
		phoneField.attr("placeholder", "+7 (___) ___-__-__*");
	}
});

phoneField.on("input", (event) => {
	const elem = $(event.currentTarget);

	if (elem.valid()) {
		emailField.attr("required", false);
		emailField.attr("placeholder", "Введите e-mail");
		emailField.valid();
	} else {
		emailField.attr("required", true);
		emailField.attr("placeholder", "Введите e-mail*");
	}

	if (elem.val().length < 1 && emailField.val().length < 1) {
		elem.attr("required", true);
		elem.attr("placeholder", "+7 (___) ___-__-__*");
		emailField.attr("required", true);
		emailField.attr("placeholder", "Введите e-mail*");
	}

	if (elem.val().length < 1 && emailField.valid()) {
		elem.attr("required", false);
		elem.attr("placeholder", "+7 (___) ___-__-__");
	}
});
